<script>
export default {
  name: 'VSlider',
  functional: true,

  props: {
    currentSlideIndex: {
      type: Number,
      required: true,
    },

    transitionName: {
      type: String,
      default: 'fade',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  render(createElement, context) {
    const { props, children } = context;

    return createElement('transition', {
      attrs: {
        name: props.transitionName,
        mode: 'out-in',
        appear: true,
      },
    }, [createElement('div', {
      class: {
        slider: true,
      },
      key: props.currentSlideIndex,
    }, props.disabled ? children : [children[props.currentSlideIndex]])]);
  },
};
</script>
